import { makeStyles } from '@material-ui/styles';
import { Grid, Typography } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CardDailyDose from './CardDailyDose';
import { getDoseDetails } from '../../redux/actions/DealershipActions';
const useStyles = makeStyles(() => ({
  cardContainer: {
    height: '104px',
  },
  content: {
    height: '65vh',
    overflowY: 'auto',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  leftContentHolder: {
    alignItems: 'flex-start',
    padding: '8px',
    height: '56px',
    top: '0px',
  },
  leftContentTitleText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '22px',
    color: 'rgba(0, 0, 0, 0.4)',
    opacity: '0.7',
  },
  plusButton: {
    width: '24px',
    height: '24px',
    marginLeft: 'calc(50% - 24px/2 - 1px)',
    marginTop: 'calc(50% - 24px/2)',
    border: 'none',
    background: 'white',
    cursor: 'pointer',
  },
  plusIcon: {
    width: '16px',
    height: '16px',
    marginLeft: '4px',
    marginTop: '4px',
    background: 'rgba(0, 0, 0, 0.4)',
  },
}));

const LeftDailyDoseContent = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const doses = useSelector((state) => state.getDoses.doses);
  useEffect(() => {
    dispatch(getDoseDetails(doses[0]));
  }, [doses, dispatch]);
  return (
    <div>
      <Grid container direction="column">
        <Grid item>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignContent="center"
            className={classes.leftContentHolder}
          >
            <Grid item>
              <Typography className={classes.leftContentTitleText}>
                {doses.length} {doses?.length > 1 ? 'Stories' : 'Story'}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item className={classes.content}>
          <Grid container direction="column">
            {Object.keys(doses).map((keyName) => (
              <Grid item className={classes.cardContainer}>
                <CardDailyDose doses={doses[keyName]} selected={false} />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default LeftDailyDoseContent;
